import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from '@auth0/auth0-react';

import ReactGA from "react-ga4";

ReactGA.initialize("G-P20793DP0F");
ReactGA.send({
  hintType:"pageView",
  page:window.location.pathname
})




const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Auth0Provider
      domain="dev-stgmkudcmvo2krke.us.auth0.com"
      clientId="kRwBdAcFl3x7r593gcx4OUtuTFhio5Oa"
      authorizationParams={{
        redirect_uri: window.location.origin
      }}
    >
      <App />
    </Auth0Provider>,
  );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
